import ExperienceAmenities from './ExperienceAmenities';

export default ExperienceAmenities;
